type UpdateUserInput = {
	school?: string;
	gradYear?: number;
	examDate?: string;
	name?: string;
	firstName?: string;
	lastName?: string;
};

const updateUserInfo = async (
	_email: string,
	_appId: string,
	_userInfo: UpdateUserInput,
): Promise<boolean> => {
	return true;
};

export default updateUserInfo;
